import { secureStorage } from "@/utils/secureStorage";

/**
 * Retrieves budget calculations from secureStorage
 */
export const getBudgetCalculationsFromStorage = () => {
  // Try secureStorage first, then fall back to localStorage
  let budgetInfo = secureStorage.get<any>('budgetCalculations');
  
  if (!budgetInfo) {
    const budgetString = localStorage.getItem('budgetCalculations');
    budgetInfo = budgetString ? JSON.parse(budgetString) : {};
  }
  
  console.log("Retrieved budget info:", budgetInfo);
  return budgetInfo;
};

/**
 * Calculates the total amount based on devices, duration, and budget info
 */
export const calculateTotalAmount = (
  devices: number, 
  duration: number, 
  budgetInfo: any
): number => {
  // Use total budget from budget calculations if available
  // Support both totalBudget and totalAmount keys
  const amount = budgetInfo.totalBudget || budgetInfo.totalAmount || (devices * duration * 10);
  console.log(`Calculated amount: ${amount}`);
  return amount;
};
